import React, { useRef, useEffect } from 'react';
import InitialMessage from './IntialMessage';
import ChatMessage from './ChatMessage';

const ChatMessages = ({
    ovr,
    getStaffInfo,
    isMessageFromCurrentUser
}) => {
    const chatEndRef = useRef(null);

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (ovr?.comments) {
            scrollToBottom();
        }
    }, [ovr?.comments]);

    if (!ovr) return null;

    return (
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden p-2 sm:p-4 bg-gray-50">

            {/* Initial Message always first */}
            <InitialMessage ovr={ovr} getStaffInfo={getStaffInfo} />

            {ovr.comments && ovr.comments.length > 0 && ovr.comments.slice().reverse().map((comment, index) => (
                <ChatMessage
                    key={index}
                    comment={comment}
                    isCurrentUser={isMessageFromCurrentUser(comment.userId)}
                    getStaffInfo={getStaffInfo}
                />
            ))}

            <div ref={chatEndRef} />
        </div>
    );
};

export default ChatMessages;